module.exports = __webpack_public_path__ + "img/agenda.b6a23831.png";